import { Fragment } from "react";
import PageBreadcrumb from "elements/System/PageBreadcrumb";

export default function Starter() {
  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Starter", path: "/pages/starter", active: true },
        ]}
        title={"Starter"}
      />
      <p>Starter</p>
    </Fragment>
  );
}
